import React, { useEffect, useState } from 'react';
// Import skelton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Buffer } from "buffer";

import Button from "../components/button/button";

import sampleFile from "../asstes/sample.pdf";

// Import the main component
import { Viewer, Worker, SpecialZoomLevel } from "@react-pdf-viewer/core";

// Import supabase configuration
import supabase from "../config/supabase";

import moment from "moment";

function ClientViewProfile() {
    
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [profile, setProfile] = useState([]);

    useEffect( async() => {
        document.title = "Client View Profile";
        var currentProfileId = localStorage.getItem('clientBoardProfile');

        var url = new URL(window.location.href);

        var client_invitation_id = url.searchParams.get("id");
        client_invitation_id = Buffer.from(client_invitation_id || "", "base64").toString("utf-8");

        await getBoardProfiles(client_invitation_id, currentProfileId);
    },[])

    const getBoardProfiles = async (id, currentProfileId) => {
        var client = [];
          var { data, error } = await supabase
            .from("board_clients_invitation")
            .select("*,board(*)")
            .match({ id: id});
    
          if (data && data.length) {
            client = data;
          }
        var profiles = await getAllProfiles(currentProfileId);
        var currentProfileIndexInClientTable = client[0].profiles.findIndex( (clientprofile) => clientprofile.id === currentProfileId)
                if(client[0].profiles[currentProfileIndexInClientTable].meetingTime){
                // Start meeting time
                let date  = new Date(client[0].profiles[currentProfileIndexInClientTable].meetingTime);
                profiles.meetingTime = moment(date).format('MMM D, h:mm A') ;

                profiles.fullMeetingTime = moment(date).format('ddd MMM D YYYY HH:mm:ss') ;

                // End meeting time
                let endDate  = client[0].profiles[currentProfileIndexInClientTable].endMeetingTime && new Date(client[0].profiles[currentProfileIndexInClientTable].endMeetingTime);
                profiles.endMeetingTime = endDate ? moment(endDate).format('h:mm A') : "";
                }
                else{
                profiles.meetingTime = client[0].profiles[currentProfileIndexInClientTable].meetingTime || '';
                profiles.endMeetingTime = client[0].profiles[currentProfileIndexInClientTable].endMeetingTime || '';
                }
    
                // Client hourly rate
                profiles.client_hourly_rate = client[0].profiles[currentProfileIndexInClientTable].rate;
    
        setProfile(profiles);
        setShowLoader(false);
        setLoading(false);
      };
    
      const getAllProfiles = async (id) => {
          const { data, error } = await supabase
          .from("all_profiles")
          .select("*")
          .match({id: id});
    
          if(data && data.length > 0) {
            var profile = { ...data[0], status: id.status, meetingTime: id.meetingTime, cancelUrl: id.cancel_url ? id.cancel_url : '', rescheduleUrl: id.reschedule_url ? id.reschedule_url : '', event_uuid: id.event_uuid ? id.event_uuid : '' };
            return profile
          } else {
            console.log('no profiles');
          }
      };

  return (
    <div
    className={`col-span-12`}
    >
        {/* Add div */}
        <div className="bg-profile_background h-2xl w-full col-span-12"></div>

        {/* Body */}
        <div className="bg-blue-7 flex justify-center">
        <div className="w-11/12 lg:self-center ">
            {/* Personal View Sections */}
            <div className="col-span-12 grid grid-cols-12 gap-3 -mt-5">
            {/* Basic Info section */}
            <div className="bg-white-1 col-span-12 grid grid-cols-12 gap-3 rounded font-Poppins pl-10 pt-5  pb-1 mb-1">
                {/* DP and Interview Button*/}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    <div className="col-span-6 h-20 w-20 -mt-24 md:h-40 md:w-40 md:-mt-28">
                        <Skeleton
                        circle={true}
                        height={`100%`}
                        width={`100%`}
                        />
                    </div>
                    </div>
                ) : (
                    <div
                    className={`col-span-12 grid grid-cols-12 gap-3`}
                    >
                    <div className="col-span-5 h-30 w-30 -mt-24 md:h-40 md:w-40 md:-mt-28 rounded-full bg-white-1 border-grey-1 border-2 relative">
                        <img
                        className={`h-28 w-22 flex justify-center items-center mt-5 absolute left-8`}
                        src={profile?.emoji_url}
                        alt="Avatar"
                        />
                    </div>
                    <div className="col-span-7 flex justify-end mr-5">
                        {
                        (profile?.meetingTime && !showLogin) && <div className="bg-pink-1 h-10 flex items-center text-base text-white-1 px-5 rounded-md">
                            Meeting: {profile?.meetingTime} - {profile?.endMeetingTime}
                        </div>
                        }
                    </div>
                    </div>
                )}
                </div>

                {/* Name */}
                <div className="col-span-12">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 mt-2 grid grid-cols-12 gap-3">
                    <div className="col-span-12 md:col-span-3">
                        <Skeleton height={35} width={300} />
                    </div>
                    </div>
                ) : (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    {/* Add text */}
                    <div
                        className={`flex col-span-12 md:col-span-8 lg:col-span-9`}
                    >
                        <span className="text-black-1 text-2xl font-semibold">
                        {profile?.full_name}
                        </span>
                    </div>
                    </div>
                )}
                </div>

                {/* Location and TimeZone */}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 flex">
                    <Skeleton height={30} width={260} />
                    <div className="ml-40">
                        <Skeleton height={30} width={140} />
                    </div>
                    </div>
                ) : (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    {/* Add location */}
                    {profile?.location && (
                        <div className="col-span-12 grid grid-cols-12">
                        <div className="flex col-span-12 md:col-span-6">
                            <img
                            className="mr-1 h-4 mt-1"
                            src="/location_icon2.svg"
                            alt="Avatar"
                            />
                            <span className="text-black-1 text-base font-light">
                            {profile?.location}
                            </span>
                        </div>
                        <div className="flex col-span-12 md:col-span-6">
                            {/* Render exp */}
                            {profile?.timezone ? (
                            <div className="text-base font-light flex">
                                <svg
                                className="mt-1 h-4 w-4 fill-current text-black-1 mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="18"
                                height="18"
                                >
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z" />
                                </svg>
                                {profile?.timezone
                                .split(" ")[0]
                                .replace(/[\(\)]/g, "")}
                            </div>
                            ) : null}
                        </div>
                        </div>
                    )}
                    </div>
                )}
                </div>

                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 flex">
                    <Skeleton height={30} width={260} />
                    <div className="ml-40">
                        <Skeleton height={30} width={140} />
                    </div>
                </div>
                ) : (
                    <div className="grid grid-cols-12 gap-3 col-span-12">
                    {/* Add job title */}
                    <div className="col-span-12 grid grid-cols-12">
                        <div className="flex col-span-12 md:col-span-6">
                        {/* Render exp */}
                        {profile?.exp ? (
                            <div className="w-full text-xs font-normal text-black-2">
                            <div>EXPERIENCE</div>
                            <div className="text-black-1 text-sm">
                                {/* Text */}
                                {profile?.exp} Years
                            </div>
                            </div>
                        ) : null}
                        </div>
                        <div className="flex col-span-12 md:col-span-6">
                        {/* Render expected_hourly_rate */}
                        {profile?.client_hourly_rate ? (
                            <div className="w-full text-sm font-semibold text-black-1">
                            <div className="text-black-2 text-xs font-normal">
                                {" "}
                                HOURLY RATE
                            </div>
                            {/* Text */}
                            <div>${profile?.client_hourly_rate}</div>
                            </div>
                        ) : null}
                        </div>
                    </div>
                    </div>
                )}
                </div>

                {/* Add text */}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <Skeleton height={35} width={330} />
                ) : (
                    <div className="col-span-12">
                    {/* Show skills */}
                    <div className="col-span-12 md:col-span-10 flex flex-wrap">
                        {/* Render tags */}
                        {profile?.skill_level.length > 0
                        ? profile?.skill_level.map((element, index) => (
                            <div
                                key={index}
                                className={`text-black-1 text-sm p-1 mr-2 mb-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
                            >
                                {element.skill}
                            </div>
                            ))
                        : null}
                    </div>
                    </div>
                )}
                </div>
            </div>

            {/* Show download */}
            <div className="col-span-12 bg-white-1 rounded font-Poppins p-5 mb-5">
                {loading ? (
                <div className="col-span-12">
                    <div className="">
                    <Skeleton height={35} width={300} />
                    </div>
                </div>
                ) : (
                <div>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js">
                    <div
                        style={{
                        border: "1px solid rgba(0, 0, 0, 0.3)",
                        height: "1050px",
                        }}
                    >
                        <Viewer
                        fileUrl={profile?.cv_link ? profile?.cv_link : sampleFile}
                        />
                    </div>
                    </Worker>
                </div>
                )}
                {!loading && <div className="flex justify-start mt-5">
                {
                    (profile?.meetingTime && !showLogin) && <div className="bg-pink-1 h-10 flex items-center text-base text-white-1 px-5 rounded-md">
                    Meeting: {profile?.meetingTime} - {profile?.endMeetingTime}
                    </div>
                }
                </div>}
            </div>
            </div>
        </div>
        </div>
    </div>
  )
}

export default ClientViewProfile